import React, { useEffect, useState, useRef } from "react";
import { ListBox } from "primereact/listbox";
import { Checkbox } from "primereact/checkbox";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/loader";
import { APIResponseEntity } from "../../../interface/api-responce";
import {
    APIExportOfficeCoverageList,
    APIFetchUnMappedCityByStateId,
    APIGetOfficeById,
    APIGetStateDDL,
    APISaveRegionsMapping,
} from "../../../service/api-service";
import { CityDDLEntity, StateDDLEntity } from "../../../interface/order";
import {
    IsNullOrEmptyArray,
    IsNullOrUndefined,
    IsStringNullEmptyOrUndefined,
} from "../../../utils/null-check";
import { toastOptObj } from "../../../utils/constants";
import {
    CityEntityOffice,
    GetRegionDetailsEntity,
    RegionDetailsEntity,
    StateEntityOffice,
    ViewRegionWiseReqEntity,
} from "../../../interface/offices";
import OfficeCitiesMappingMap from "./office-cities-mapping-map";
import { downloadCsvFile } from "../../../service/shared.service";

function RegionWiseOfficeCitiesMapping() {
    const navigate = useNavigate();
    const mapRef = useRef<{ getSelectedAreas: () => RegionDetailsEntity[] } | null>(null);
    const [selectedStates, setSelectedStates] = useState<StateEntityOffice[]>([]);
    const [selectedAllCites, setSelectedAllCites] = useState<boolean>(false);
    const [selectedCities, setSelectedCities] = useState<CityEntityOffice[]>([]);
    const [unselectedCities, setUnselectedCities] = useState<CityEntityOffice[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [cityDDL, setCityDDL] = useState<CityDDLEntity[]>([]);
    const [allSelectedCities, setAllSelectedCities] = useState<CityDDLEntity[]>(
        []
    );
    const [officeId, setOfficeId] = useState<string>("");
    const [officeDetails, setOfficeDetails] =
        useState<GetRegionDetailsEntity | null>(null);
    const [searchKeywordState, setSearchKeywordState] = useState<string>("");
    const [searchKeywordCity, setSearchKeywordCity] = useState<string>("");

    useEffect(() => {
        const fetchDefaultData = async (): Promise<void> => {
            const queryParams = new URLSearchParams(window.location.search);
            let myParam: string | null = queryParams.get("officeId");
            setIsLoading(true);
            if (myParam && !IsStringNullEmptyOrUndefined(myParam)) {
                try {
                    await fetchOfficeById(myParam);
                    // await fetchStateDDL();
                    setOfficeId(myParam);
                    setIsLoading(false);
                } catch (error) {
                    console.log(error);
                    setIsLoading(false);
                }
            }
        };
        fetchDefaultData();
    }, []);


    useEffect(() => {
        const allCitiesVisible = cityDDL.every((city) => city.isVisible);
        setSelectedAllCites(allCitiesVisible);
    }, [cityDDL]);

    // useEffect(() => {
    //     if (
    //         officeDetails &&
    //         !IsNullOrEmptyArray(officeDetails.distributedRegions)
    //     ) {
    //         console.log(officeDetails.distributedRegions);
    //         const modifiedArray = officeDetails.distributedRegions.map(
    //             (item: any) => {
    //                 return {
    //                     ...item,
    //                     cityId: item.cityId,
    //                     id: item.cityId,
    //                 };
    //             }
    //         );
    //         setAllSelectedCities(modifiedArray);
    //     }
    // }, [officeDetails]);

    useEffect(() => {
        if (
            officeDetails &&
            !IsNullOrUndefined(officeDetails)
        ) {
            setSelectedCities(officeDetails.distributedRegions);
            setUnselectedCities(officeDetails.nonDistributedRegions);
        }
    }, [officeDetails]);

    const handleStateChange = (e: any) => {
        console.log(e)
        setSelectedStates(e.value);
        if (e.value && e.value.id) {
            fetchCityDDL(e.value.id);
        }
    };

    const cityTemplate = (option: CityEntityOffice) => (
        <div className="d-flex flex-wrap align-items-center">
            <div className="p-checkbox-region">
                <Checkbox
                    inputId={`checkbox_${option.id}`}
                    value={option}
                    className="me-2"
                    onChange={(e) => {
                        const newChecked = !!e.target.checked;
                        onSelectCitiesList(newChecked, option.id);
                    }}
                    checked={option.isVisible || false}
                />
                <span>{option.name}</span>
            </div>
        </div>
    );

    const fetchOfficeById = async (officeId: string): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIGetOfficeById(
            officeId, false
        );
        setIsLoading(false);
        if (resp && resp.status === 200) {
            const axiosResp: APIResponseEntity = resp.data;
            if (axiosResp.data && axiosResp.statusCode === 200) {
                setOfficeDetails(axiosResp.data);
            } else {
                toast.error(axiosResp.message, { ...toastOptObj });
            }
        } else {
            toast.error(resp?.data?.message || "Failed to fetch office details", {
                ...toastOptObj,
            });
        }
    };

    const fetchStateDDL = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIGetStateDDL();
        setIsLoading(false);

        if (resp && resp.status === 200) {
            const axiosResp: APIResponseEntity = resp.data;
            if (axiosResp.data && axiosResp.statusCode === 200) {
                const sortedStates = axiosResp.data.data.sort(
                    (a: StateDDLEntity, b: StateDDLEntity) => a.name.localeCompare(b.name)
                );
                // setStateDDL(sortedStates);
            } else {
                toast.error(axiosResp.message, { ...toastOptObj });
            }
        } else {
            toast.error(resp?.data?.message || "Failed to fetch states", {
                ...toastOptObj,
            });
        }
    };

    const fetchCityDDL = async (stateId: number): Promise<void> => {
        if (stateId) {
            try {
                setIsLoading(true);
                const resp: AxiosResponse<APIResponseEntity> =
                    await APIFetchUnMappedCityByStateId(stateId);
                setIsLoading(false);
                if (resp && resp.status === 200) {
                    const axiosResp: APIResponseEntity = resp.data;
                    if (axiosResp.data && axiosResp.statusCode === 200) {
                        const modifiedArray = axiosResp.data.cities.map((item: any) => {
                            return {
                                ...item,
                                cityId: item.id,
                            };
                        });
                        const sortedCities = modifiedArray.sort(
                            (a: CityDDLEntity, b: CityDDLEntity) =>
                                a.name.localeCompare(b.name)
                        );
                        const updatedCities = updateCityVisibility(
                            sortedCities,
                            officeDetails &&
                                !IsNullOrEmptyArray(officeDetails.distributedRegions)
                                ? officeDetails.distributedRegions
                                : [],
                            stateId
                        );
                        const sortCity = updatedCities.sort(
                            (a: CityDDLEntity, b: CityDDLEntity) =>
                                a.name.localeCompare(b.name)
                        );
                        setCityDDL(sortCity);
                    } else {
                        toast.error(axiosResp.message, { ...toastOptObj });
                    }
                } else {
                    toast.error(resp?.data?.message || "Failed to fetch cities", {
                        ...toastOptObj,
                    });
                }
            } catch (error) {
                setIsLoading(false);
                toast.error("Failed to fetch cities", { ...toastOptObj });
            }
        }
    };

    const updateCityVisibility = (
        cities: CityDDLEntity[],
        data: any,
        stateId: number
    ): CityDDLEntity[] => {
        const arrCity: any[] = [];

        let newArray: any[] = [...cities];

        const modifiedArray = data.map((item: any) => ({
            id: item.cityId,
            stateId: item.stateId,
            name: item.cityName,
            cityId: item.cityId,
        }));

        const sortedCities = modifiedArray.sort((a: any, b: any) =>
            a.name.localeCompare(b.name)
        );

        sortedCities.forEach((item1: any) => {
            const existsInNewArray = newArray.some(
                (item2: any) =>
                    item2.cityId === item1.cityId && item2.stateId === item1.stateId
            );
            if (
                !existsInNewArray &&
                !IsNullOrEmptyArray(cities) &&
                item1.stateId === cities[0].stateId
            ) {
                newArray.push(item1);
            }
        });

        if (IsNullOrEmptyArray(newArray)) {
            let newArray: CityDDLEntity[] = [];

            const modifiedArray = data.map((item: any) => ({
                id: item.cityId,
                stateId: item.stateId,
                name: item.cityName,
                cityId: item.cityId,
            }));
            const sortedCities = modifiedArray.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
            );
            sortedCities.forEach((item: any) => {
                if (item.stateId === stateId) {
                    newArray.push(item);
                }
            });
            newArray = newArray.map((city: CityDDLEntity) => ({
                ...city,
                isVisible: true,
            }));
            arrCity.push(newArray);
        }

        const checkCitiesMap = !IsNullOrEmptyArray(newArray)
            ? newArray
            : arrCity[0];

        return checkCitiesMap.map((city: any) => {
            const isVisibleFromSelectedCities = allSelectedCities.some(
                (selectedCity) =>
                    selectedCity.cityId === city.cityId &&
                    selectedCity.stateId === city.stateId
            );
            return {
                ...city,
                isVisible: isVisibleFromSelectedCities,
            };
        });
    };

    const onSelectCitiesList = (checked: boolean, id: number) => {
        const updatedCityDDL = cityDDL.map((item) =>
            item.id === id ? { ...item, isVisible: checked } : item
        );
        setCityDDL(updatedCityDDL);

        const updatedAllSelectedCities = checked
            ? [...allSelectedCities, cityDDL.find((city) => city.id === id)!]
            : allSelectedCities.filter((city) => city.id !== id);

        setAllSelectedCities(updatedAllSelectedCities);
    };

    const handleSelectAll = (e: any) => {
        const checked = e.target.checked;

        setSelectedAllCites(checked);
        const updatedCityDDL = cityDDL.map((city) => ({
            ...city,
            isVisible: checked,
        }));
        setCityDDL(updatedCityDDL);

        const updatedAllSelectedCities = checked
            ? [
                ...allSelectedCities,
                ...cityDDL.filter(
                    (city) =>
                        !allSelectedCities.some(
                            (selectedCity) => selectedCity.id === city.id
                        )
                ),
            ]
            : allSelectedCities.filter(
                (city) => !cityDDL.some((cityDDLItem) => cityDDLItem.id === city.id)
            );
        setAllSelectedCities(updatedAllSelectedCities);
    };

    const handleSubmit = async () => {
        try {
            // Get selected areas from map using ref
            const mapSelectedAreas = mapRef.current?.getSelectedAreas() || [];

            const mapping: RegionDetailsEntity[] = mapSelectedAreas.map((item) => ({
                officeId: officeId,
                city_providerId: item.city_providerId,
                division_providerId: item.division_providerId,
                state_providerId: item.state_providerId,
                country_providerId: item.country_providerId,
                placeType: item.type || 'LOCALITY',
            }));

            const reqObj: ViewRegionWiseReqEntity = {
                mapping: mapping,
                officeId: officeId,
            };

            if (!IsNullOrEmptyArray(reqObj.mapping)) {
                setIsLoading(true);
                const resp: AxiosResponse<APIResponseEntity> =
                    await APISaveRegionsMapping(reqObj);
                setIsLoading(false);
                if (resp && resp.status === 201) {
                    const axiosResp: APIResponseEntity = resp.data;
                    if (axiosResp.data && axiosResp.statusCode === 201) {
                        toast.success(axiosResp.message, { ...toastOptObj });
                        navigate("/settings/offices");
                    } else {
                        toast.error(axiosResp.message, { ...toastOptObj });
                    }
                } else {
                    toast.error(
                        resp?.data?.message || "Failed to save region-wise office mapping",
                        { ...toastOptObj }
                    );
                }
            }
        } catch (error) {
            console.error(
                "Error while submitting region-wise office mapping:",
                error
            );
        }
    };

    const filterTemplateState = () => {
        return (
            <div className="flex flex-column gap-2">
                <div className="input-group search-grp">
                    <img
                        src="assets/images/search.svg"
                        alt="search"
                        className="input-group-text searchIptGrpTxt"
                    />
                    <input
                        type="text"
                        className="form-control form-control-lg searchInput"
                        placeholder="Search state"
                        value={searchKeywordState}
                        onChange={(e) => setSearchKeywordState(e.target.value)}
                    />
                    {!IsStringNullEmptyOrUndefined(searchKeywordState) && (
                        <button
                            className="btn btn-cancel text-dark search-button-clear"
                            type="button"
                            onClick={() => {
                                setSearchKeywordState("");
                                setCityDDL([]);
                                setSelectedStates([]);
                            }}
                        >
                            Clear
                        </button>
                    )}
                </div>
            </div>
        );
    };

    const filterTemplateCity = () => {
        return (
            <div className="flex flex-column gap-2">
                <div className="input-group search-grp">
                    <img
                        src="assets/images/search.svg"
                        alt="search"
                        className="input-group-text searchIptGrpTxt"
                    />
                    <input
                        type="text"
                        className="form-control form-control-lg searchInput"
                        placeholder="Search cities"
                        value={searchKeywordCity}
                        onChange={(e) => setSearchKeywordCity(e.target.value)}
                    />
                    {!IsStringNullEmptyOrUndefined(searchKeywordCity) && (
                        <button
                            className="btn btn-cancel text-dark search-button-clear"
                            type="button"
                            onClick={() => setSearchKeywordCity("")}
                        >
                            Clear
                        </button>
                    )}
                </div>
            </div>
        );
    };

    const handleExportOfficeCoverageList = async () => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIExportOfficeCoverageList(officeId);
        setIsLoading(false);

        if (resp) {
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const excelUrl = axiosResp.data.xlsxOfficesUrl;
                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName: string = excelUrl.split("/").pop();
                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName);
                        }
                    }
                }
            } else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }
    }

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="content-wrapper">
                <div className="row">
                    <div className="col-12">
                        <div className="card card-rounded">
                            <div className="card-body">

                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <h4 className="card-title">Region wise offices</h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button
                                            type="button"
                                            className="btn btn-block btn-success btn-md font-weight-medium m-0 me-2"
                                            onClick={handleExportOfficeCoverageList}
                                        >
                                            Export Office Coverage List
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleSubmit}
                                            className="btn btn-block btn-primary btn-md font-weight-medium m-0 me-2"
                                        // disabled={IsNullOrEmptyArray(allSelectedCities)}
                                        >
                                            Save Region Wise Office
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-cancel text-dark m-0"
                                            onClick={() => navigate("/settings/offices")}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-6 mt-2">
                                        <h6 className="m-sm-0 text-gray">Office Name</h6>
                                        <h6 className="mt-2 fw-bold">
                                            {officeDetails?.data.officeName}
                                        </h6>
                                    </div>
                                    <div className="col-6 mt-2">
                                        <h6 className="m-sm-0 text-gray">Address</h6>
                                        <h6 className="mt-2 fw-bold">
                                            {officeDetails?.data.addressLine1} &nbsp;&nbsp;
                                            {officeDetails?.data.addressLine2}
                                        </h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <OfficeCitiesMappingMap
                                        ref={mapRef}
                                        currentOffice={{
                                            id: officeId,
                                            name: officeDetails && officeDetails.data.officeName ? officeDetails.data.officeName : '',
                                            color: '#E65100'
                                        }}
                                        assignments={[...selectedCities, ...unselectedCities]}
                                        initialSelectedCities={selectedCities.map(place => ({
                                            officeId: officeId,
                                            city_providerId: place.city_providerId,
                                            division_providerId: place.division_providerId,
                                            state_providerId: place.state_providerId,
                                            country_providerId: place.country_providerId,
                                            type: place.placeType || 'LOCALITY',
                                            placeName: place.placeName || ''
                                        }))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RegionWiseOfficeCitiesMapping;
